import React from 'react';
import { DashboardCard } from './DashboardCard';
import { TruckIcon, PackageIcon, WarehouseIcon, ClockIcon, CheckCircleIcon, AlertCircleIcon, ArrowUpIcon, ArrowDownIcon, BarChart3Icon, DollarSignIcon, FilterIcon, ArrowUpDownIcon, GlobeIcon } from 'lucide-react';
export function OrdersOverview() {
  // Mock data
  const orderStats = {
    active: 22,
    value: '$2,272,301.43',
    margin: '20.78%',
    pending: {
      approval: 4,
      acknowledgment: 11,
      stock: 0,
      readyToLoad: 0,
      loading: 0
    }
  };
  const regions = [{
    name: 'Aisco EUROPE',
    value: 17,
    max: 20,
    percentage: 85
  }, {
    name: 'Aisco AMERICA',
    value: 4,
    max: 20,
    percentage: 20
  }, {
    name: 'Aisco ANZ',
    value: 1,
    max: 20,
    percentage: 5
  }];
  const dealers = [{
    name: 'Imper Regas Lda',
    count: 5,
    amount: '$225,896.83',
    missingPart: 0,
    pending: 0
  }, {
    name: 'KOAN IRRIGATION',
    count: 3,
    amount: '$175,432.21',
    missingPart: 0,
    pending: 0
  }, {
    name: 'VK SALES & SERVICE',
    count: 3,
    amount: '$157,890.45',
    missingPart: 0,
    pending: 0
  }, {
    name: 'AQUADOC',
    count: 3,
    amount: '$142,753.68',
    missingPart: 0,
    pending: 0
  }, {
    name: 'RIEGOS Y SISTEMAS JAIME BORREGO',
    count: 2,
    amount: '$98,567.32',
    missingPart: 0,
    pending: 0
  }, {
    name: 'SRL "AGROPROFI TECH"',
    count: 1,
    amount: '$76,432.19',
    missingPart: 0,
    pending: 0
  }];
  return <div className="space-y-6" data-id="element-1849" data-mp="wunh27tipn6t">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1850" data-mp="wtcegbbt6lha">
        <DashboardCard className="md:col-span-2" icon={<TruckIcon size={20} className="text-blue-400" data-id="element-1852" data-mp="1bqmwy4mvcrmi" />} title="Active Orders" subtitle="Current month" data-id="element-1851" data-mp="1bry0q4gbdzdm">
          <div className="flex flex-col" data-id="element-1853" data-mp="16t3a4gc3v6iy">
            <div className="text-4xl font-bold text-white mb-4" data-id="element-1854" data-mp="3di9e7egyl85s">
              {orderStats.value}
            </div>
            <div className="text-sm text-blue-300 mb-6" data-id="element-1855" data-mp="38kq2al7qh7h0">
              Average margin: {orderStats.margin}
            </div>
            <div className="flex items-center justify-between mb-4" data-id="element-1856" data-mp="240o73brjd24">
              <div className="flex items-center" data-id="element-1857" data-mp="639j4bijhgz9">
                <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center mr-3" data-id="element-1858" data-mp="6643k31jz1so">
                  <span className="text-2xl font-bold text-blue-400" data-id="element-1859" data-mp="g27dhv2nc4q6">
                    {orderStats.active}
                  </span>
                </div>
                <div className="text-sm" data-id="element-1860" data-mp="l0ikly1k414p">
                  <div className="text-white font-medium" data-id="element-1861" data-mp="p2vtgvblof5p">Active orders</div>
                  <div className="text-blue-300" data-id="element-1862" data-mp="p0ssjg8wt1m7">Last updated today</div>
                </div>
              </div>
              <div className="flex items-center space-x-2" data-id="element-1863" data-mp="tvye2dyege9r">
                <div className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-300 text-sm" data-id="element-1864" data-mp="yrdqd1gre242">
                  This Month
                </div>
                <div className="px-3 py-1 rounded-full bg-slate-800 text-blue-300 text-sm cursor-pointer hover:bg-slate-700" data-id="element-1865" data-mp="18qw6t7xgn5rd">
                  Last Month
                </div>
              </div>
            </div>
            <div className="h-40 relative" data-id="element-1866" data-mp="2oa3ti4h1jxwp">
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between px-2" data-id="element-1867" data-mp="2o898kq5rs5sm">
                {Array.from({
                length: 12
              }, (_, i) => <div key={i} className="flex flex-col items-center" data-id="element-1868" data-mp="2ec6abve1gray">
                      <div className="w-8 bg-blue-500 rounded-t-sm" style={{
                  height: `${Math.random() * 100 + 20}px`
                }} data-id="element-1869" data-mp="3bzey5x1iicg4"></div>
                      <div className="text-xs text-blue-300 mt-1" data-id="element-1870" data-mp="370twdt6m3kpk">
                        {new Date(0, i).toLocaleString('default', {
                    month: 'short'
                  })}
                      </div>
                    </div>)}
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<ClockIcon size={20} className="text-amber-400" data-id="element-1872" data-mp="3pz67vlkzx6ob" />} title="Pending Status" data-id="element-1871" data-mp="3urzc88cjyczv">
          <div className="space-y-6" data-id="element-1873" data-mp="3px3bmjt92hb5">
            <div className="grid grid-cols-3 gap-4" data-id="element-1874" data-mp="3agn0mts9qujz">
              <StatusItem value={orderStats.pending.approval} label="Approval" color="amber" data-id="element-1875" data-mp="3aj9bp3edbs6y" />
              <StatusItem value={orderStats.pending.acknowledgment} label="Acknowledgment" color="blue" data-id="element-1876" data-mp="3fe6gfy4m7fe1" />
              <StatusItem value={orderStats.pending.stock} label="Stock" color="emerald" data-id="element-1877" data-mp="30l3c4sg1ay59" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-1878" data-mp="35jwm4aw4470o">
              <StatusBox icon={<WarehouseIcon size={18} className="text-blue-300" data-id="element-1880" data-mp="3t8622w6na0jw" />} value={orderStats.pending.readyToLoad} label="Ready to load" data-id="element-1879" data-mp="3t8z2zgix9vu4" />
              <StatusBox icon={<TruckIcon size={18} className="text-blue-300" data-id="element-1882" data-mp="3ji4jgjx29acd" />} value={orderStats.pending.loading} label="Loading" data-id="element-1881" data-mp="3jhup6k4zgh0v" />
            </div>
          </div>
        </DashboardCard>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1883" data-mp="g14e3qujndsb">
        <DashboardCard icon={<GlobeIcon size={20} className="text-blue-400" data-id="element-1885" data-mp="fz1hgnyvymem" />} title="Regional Distribution" className="md:col-span-3" data-id="element-1884" data-mp="fzl066wd1etp">
          <div className="space-y-4" data-id="element-1886" data-mp="25i9p1avzi2q9">
            {regions.map(region => <div key={region.name} className="space-y-2" data-id="element-1887" data-mp="25gordcedi3o6">
                <div className="flex justify-between" data-id="element-1888" data-mp="20jyfl19lpu8k">
                  <span className="text-sm text-blue-300" data-id="element-1889" data-mp="20h2ej42gipfw">{region.name}</span>
                  <span className="text-sm font-medium text-white" data-id="element-1890" data-mp="2f7jjuyi7pzi2">
                    {region.value} orders
                  </span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-2.5 overflow-hidden" data-id="element-1891" data-mp="1mivsqmas8fwl">
                  <div className="bg-blue-500 h-2.5 rounded-full" style={{
                width: `${region.percentage}%`
              }} data-id="element-1892" data-mp="1hkkkgg04ydgh"></div>
                </div>
                <div className="flex justify-between text-xs text-slate-400" data-id="element-1893" data-mp="1vhzc7rdv2xbm">
                  <span data-id="element-1894" data-mp="1rgxbf64aqd7j">0</span>
                  <span data-id="element-1895" data-mp="1rkusznb86wpb">{region.max}</span>
                </div>
              </div>)}
          </div>
        </DashboardCard>
      </div>
      <DashboardCard icon={<BarChart3Icon size={20} className="text-blue-400" data-id="element-1897" data-mp="32wvnliurtfcz" />} title="Orders by Dealers" footer={<div className="flex justify-between text-sm text-blue-300" data-id="element-1898" data-mp="1zlokrro9ky9f">
            <span data-id="element-1899" data-mp="24lkqpwgiuzrm">Showing 6 of 24 dealers</span>
            <button className="text-blue-400 hover:text-white" data-id="element-1900" data-mp="24k9klpzltfxc">View All</button>
          </div>} data-id="element-1896" data-mp="32yf51cs5xwgc">
        <div className="flex justify-end mb-4" data-id="element-1901" data-mp="29m8n6xnis8t8">
          <div className="flex items-center space-x-2" data-id="element-1902" data-mp="2dmiy8oq65pey">
            <button className="p-2 rounded-lg bg-slate-800 text-blue-300 hover:bg-slate-700 transition-colors" data-id="element-1903" data-mp="2dlzed2gykqya">
              <ArrowUpDownIcon size={16} data-id="element-1904" data-mp="1gu5ixo5z7q8z" />
            </button>
            <button className="p-2 rounded-lg bg-slate-800 text-blue-300 hover:bg-slate-700 transition-colors" data-id="element-1905" data-mp="1lwed2nul4yco">
              <FilterIcon size={16} data-id="element-1906" data-mp="1pw53gqg79cgo" />
            </button>
            <div className="relative" data-id="element-1907" data-mp="1unerjmm3o7qg">
              <select className="appearance-none bg-slate-800 text-blue-300 rounded-lg px-3 py-1.5 pr-8 text-sm border border-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1908" data-mp="1uoga0c5g3wi7">
                <option data-id="element-1909" data-mp="1261add0n0v3x">Active orders</option>
                <option data-id="element-1910" data-mp="124zoselzwq7y">All orders</option>
                <option data-id="element-1911" data-mp="umrzffchgocr">Completed orders</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-300" data-id="element-1912" data-mp="pozyjvtv1rwf">
                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-1913" data-mp="lmddqevlx78q">
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" data-id="element-1914" data-mp="gn0gd0740hrw" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-1915" data-mp="6wxpp6ngnfwq">
          <table className="w-full" data-id="element-1916" data-mp="1yw3icuqn0h1">
            <thead data-id="element-1917" data-mp="1zysugcewuuu">
              <tr className="text-left border-b border-slate-700" data-id="element-1918" data-mp="1x2xmzry8ka3">
                <th className="pb-3 font-medium text-blue-300 text-sm" data-id="element-1919" data-mp="3u3zthny820nr">
                  Dealer
                </th>
                <th className="pb-3 font-medium text-blue-300 text-sm" data-id="element-1920" data-mp="3p3bxsoz1svn7">
                  Status
                </th>
                <th className="pb-3 font-medium text-blue-300 text-sm text-right" data-id="element-1921" data-mp="3k6vbm0besrcr">
                  Amount
                </th>
                <th className="pb-3 font-medium text-blue-300 text-sm text-right" data-id="element-1922" data-mp="1gux590gyyvg9">
                  Count
                </th>
              </tr>
            </thead>
            <tbody data-id="element-1923" data-mp="12xid3nzc09kl">
              {dealers.map((dealer, index) => <tr key={index} className="border-b border-slate-800/50 last:border-0 hover:bg-slate-800/30" data-id="element-1924" data-mp="17tpjtizjxp3l" data-mpi={index}>
                  <td className="py-3 text-white" data-id="element-1925" data-mp="t4jklv0pryvp">{dealer.name}</td>
                  <td className="py-3" data-id="element-1926" data-mp="xw1fc1c59388">
                    {dealer.pending > 0 ? <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-500/20 text-amber-300" data-id="element-1927" data-mp="xye34v4l27t7">
                        <AlertCircleIcon size={12} className="mr-1" data-id="element-1928" data-mp="o6007z1rqv5g" />
                        {dealer.pending} pending
                      </div> : <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-500/20 text-emerald-300" data-id="element-1929" data-mp="a81lgsjjcwpf">
                        <CheckCircleIcon size={12} className="mr-1" data-id="element-1930" data-mp="3rpfni5908eq6" />
                        Approved
                      </div>}
                  </td>
                  <td className="py-3 text-right text-blue-300" data-id="element-1931" data-mp="3mrmgj9zvngou">
                    {dealer.amount}
                  </td>
                  <td className="py-3 text-right" data-id="element-1932" data-mp="5g4mo3e5xmi1">
                    <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-500/20 text-blue-300" data-id="element-1933" data-mp="iuzyvi5roxw">
                      {dealer.count}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </DashboardCard>
    </div>;
}
function StatusItem({
  value,
  label,
  color
}) {
  const colors = {
    amber: 'text-amber-400',
    blue: 'text-blue-400',
    emerald: 'text-emerald-400'
  };
  return <div className="text-center" data-id="element-1934" data-mp="x8luuvud3e48">
      <div className={`text-xl font-bold ${colors[color]} mb-1`} data-id="element-1935" data-mp="x9wvwnwfa7rn">{value}</div>
      <div className="text-xs text-blue-300" data-id="element-1936" data-mp="t8thm5u0wjsj">{label}</div>
    </div>;
}
function StatusBox({
  icon,
  value,
  label
}) {
  return <div className="bg-slate-800/50 rounded-lg p-4 text-center" data-id="element-1937" data-mp="3rtzqen3dlrfk">
      <div className="flex justify-center mb-2" data-id="element-1938" data-mp="3n1oudvbrapsa">
        <div className="p-2 rounded-lg bg-slate-700/50" data-id="element-1939" data-mp="3n05aluqw5wlr">{icon}</div>
      </div>
      <div className="text-blue-300 text-xl font-bold mb-1" data-id="element-1940" data-mp="3i3545iq4qru4">{value}</div>
      <div className="text-xs text-blue-300" data-id="element-1941" data-mp="3d4tsr3k6s99s">{label}</div>
    </div>;
}